import KizMarkRequest from "../../libs/core-api-requests/service/kizMarkRequest";
import { IKizMarkDTO, IKizMarkViewDTO } from "../../libs/coreapi-dto/service/kizMark";
import CoreApiService from "../../system/api/coreApiService";
import { ServiceDataProvider } from "./Common";


export class KizMarkDataProvider extends ServiceDataProvider<IKizMarkViewDTO, IKizMarkDTO>
{
    private _coreApiService: CoreApiService

    constructor(coreApiService: CoreApiService) {
        super();
        this._coreApiService = coreApiService
    }
    
    getDataRequest(): Promise<KizMarkRequest> {
        return this._coreApiService.kizMarkRequest
    }

    getView(body: IViewBody, callback: (entity: IKizMarkDTO[], totalCount) => void) {
        this.getDataRequest()
            .then(r => r.getView(body, e => {
                if (e.respType === 'isCompleted') {
                    try {
                        callback(e.data.entities, e.data.totalCount)
                    } catch (e) {
                        console.error(e)
                    }
                }
                else
                    throw new Error(e?.message.text ?? 'ServiceDataProvider getView !isCompleted');
            }))
    }
}